import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Logo } from "@/components/Brand";
import { Button } from "@/components/ui/button";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); } catch {}
    setSent(true);
    setLoading(false);
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#0D0F12] px-6">
      <div className="w-full max-w-md rounded-2xl bg-card p-8 shadow-xl" data-testid="forgot-password-page">
        <Logo wm={28} tone="light" />
        <h2 className="mt-6 font-heading text-[22px] font-semibold">Reset your password</h2>
        {sent ? (
          <p className="mt-2 text-sm text-muted-foreground" data-testid="forgot-password-sent">
            If that email is registered and has a password, a reset link is on its way. It expires in one hour.
            Members without a password can ask an admin to resend their invitation link.
          </p>
        ) : (
          <form onSubmit={submit} className="mt-4 space-y-4" data-testid="forgot-password-form">
            <p className="text-sm text-muted-foreground">Enter your email and we will send you a link to choose a new password.</p>
            <input
              data-testid="forgot-password-email-input"
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="h-11 w-full rounded-lg border border-input bg-card px-3.5 text-sm outline-none focus:ring-2 focus:ring-ring"
              placeholder="you@company.co.uk"
            />
            <Button type="submit" disabled={loading} data-testid="forgot-password-submit-button" className="btn-brand h-11 w-full">
              {loading ? "Sending…" : "Send reset link"}
            </Button>
          </form>
        )}
        <Link to="/login" className="mt-5 block text-sm text-[#1779AC] hover:underline" data-testid="back-to-login-link">Back to sign in</Link>
      </div>
    </div>
  );
}
